import React from "react";
import { StatusBar, AvailableBar, AcceptedBar, ConfirmedBar, DeclinedBar, TooltipTicketCount, TooltipTicketLabel, TicketTooltipGrid } from "./TicketStatusBar.styles";
import { Box } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { TicketIcon } from "../TicketIcon/TicketIcon";

export interface CustomTicketStatusBarProps {
  available: number,
  pending: number,
  accepted: number,
  declined: number,
  open?: boolean,
}

export const TicketStatusBar = ({
  available,
  pending,
  accepted,
  declined,
  open,
  ...rest
}: CustomTicketStatusBarProps) => {

  const totalTickets = available + pending + accepted + declined;
  const availablePercentage = (available / totalTickets) * 100;
  const pendingPercentage = (pending / totalTickets) * 100;
  const acceptedPercentage = (accepted / totalTickets) * 100;
  const declinedPercentage = (declined / totalTickets) * 100;

  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme, color }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(30, 30, 30)',
      boxShadow: theme.shadows[1],
      borderRadius: '1rem'
    },
    [`& .${tooltipClasses.arrow}`]: {
      "&:before": {
        border: `1px solid ${color}`
      },
      color
    }
  }));

  return (
    <LightTooltip
      placement="top"
      color="#FCFCFC"
      arrow
      open={open}
      enterTouchDelay={0}
      leaveTouchDelay={600000}
      title={
        <TicketTooltipGrid>
            <TicketIcon ticketIconStyle='solid-gray' />
            <TooltipTicketCount>{available}</TooltipTicketCount>
            <TooltipTicketLabel>Available</TooltipTicketLabel>

            <TicketIcon ticketIconStyle='solid-blue' />
            <TooltipTicketCount>{pending}</TooltipTicketCount>
            <TooltipTicketLabel>Sent Ticket Offer</TooltipTicketLabel>

            <TicketIcon ticketIconStyle='solid-green' />
            <TooltipTicketCount>{accepted}</TooltipTicketCount>
            <TooltipTicketLabel>Accepted</TooltipTicketLabel>

            <TicketIcon ticketIconStyle='solid-red' />
            <TooltipTicketCount>{declined}</TooltipTicketCount>
            <TooltipTicketLabel>Declined</TooltipTicketLabel>
        </TicketTooltipGrid>
      }
    >
      <StatusBar>
        <AvailableBar sx={{width: `${availablePercentage}%`}}/>
        <AcceptedBar sx={{width: `${pendingPercentage}%`}}/>
        <ConfirmedBar sx={{width: `${acceptedPercentage}%`}}/>
        <DeclinedBar sx={{width: `${declinedPercentage}%`}}/>
      </StatusBar>
    </LightTooltip>
  );
};

export interface TicketStatusBarProps
  extends React.ComponentProps<typeof TicketStatusBar> {
  as?: React.ElementType;
}

TicketStatusBar.displayName = "TicketStatusBar";
